import React, { Component } from "react";
import TopOptions from "../components/TopOptions";
import HealthFacilitiesTable from "../components/HealthFacilitiesTable";
import styled from "styled-components";
import { connect } from "react-redux";
import { RoutesPath } from "../values/RoutesPath";
import { acl } from "../services/acl";

class HealthFacilitiesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: false,
        };
    }
    async componentDidMount() {
        document.title = "Ressources - Sobrus Labs";
        //(this.props)
    }
    render() {
        return (
            <Main_container className="Main_container">
                <TopOptions title="Établissement de santé">
                    {acl.resource.suggestion.healthcareestablishments.list && (
                        <a onClick={() => this.props.history.push(`${RoutesPath.resource.suggestion.healthcareestablishments.list}`)} className="btn_white">
                            Historique des suggestions
                        </a>
                    )}
                    {acl.resource.suggestion.healthcareestablishments.add() && (
                        <button className="btn_bleu" data-shortcut_alias="create" onClick={() => this.props.history.push(`${RoutesPath.resource.suggestion.healthcareestablishments.add}`)}>
                            Suggérer un nouvel établissement
                        </button>
                    )}
                </TopOptions>

                <HealthFacilitiesTable {...this.props} />
            </Main_container>
        );
    }
}

const Main_container = styled.div`
    height: 100%;
`;
const mapStateToProps = (state) => {
    return {
        selected: state.selcted,
    };
};
export default connect(mapStateToProps)(HealthFacilitiesPage);
